var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 62,
    viewBox: "0 0 69 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 16.8766H0V0H69V16.8766ZM1.58913 15.2874H67.4109V1.58913H1.58913V15.2874Z",
    fill: "#209BB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2764 39.1246H0V22.248H33.2764V39.1246ZM1.58913 37.5355H31.6872V23.8372H1.58913V37.5355Z",
    fill: "#209BB7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5956 61.3727H0V44.4644H48.5956V61.3727ZM1.58913 59.7836H47.0065V46.0535H1.58913V59.7836Z",
    fill: "#209BB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup16);
export default __webpack_public_path__ + "static/media/Group16.b5937a097d4ae26966b2ce8517558f6d.svg";
export { ForwardRef as ReactComponent };